import type {
  HealthcareSessionId,
  HealthcareUserId,
} from '@hc-frontend/core-types';

import type { Prospect } from '../../domain';
import type { HandleContextualTrafficRepository } from '../../domain/repositories/handle-contextual-traffic-repository';
import { getLocationParameters } from './get-location-parameters';
import { getParameters } from './get-parameters';
import { updateProspect } from './update-prospect';

export function handleContextualTrafficAdapterFactory({
  landingUrl,
  baseUrl,
}: {
  landingUrl: string;
  baseUrl: string;
}): HandleContextualTrafficRepository {
  return {
    getParameters: () => getParameters({ baseUrl, landingUrl }),
    updateProspect: (
      prospect: Prospect,
      sessionId: HealthcareSessionId,
      userId: HealthcareUserId,
    ) => updateProspect(baseUrl, prospect, sessionId, userId),
    getLocationParameters: () => getLocationParameters({ landingUrl }),
  };
}
